import React from "react";
export default function IconsAndTextComp({ title, src, onClick }) {
   return (
      <div onClick={onClick} className="d-flex flex-column align-items-center  pe-auto">
         <div>
            <img width={30} height={30} src={src} alt="iconsandtext" />
         </div>
         <div className="d-flex custom-font-text-vim">{title}</div>
      </div>
   );
}
